import { apiGet, apiPatch } from './client';
import type { IsaCreditRiskType, IsaCreditRiskTypeBatchRequest } from '../types/IsaCreditRiskType';

export function getIsaCreditRiskTypes(): Promise<IsaCreditRiskType[]> {
  return apiGet<IsaCreditRiskType[]>('/api/isa-credit-risk-types');
}

export function saveBatchIsaCreditRiskTypes(
  added: IsaCreditRiskType[],
  modified: IsaCreditRiskType[],
  deletedIds: number[],
): Promise<IsaCreditRiskType[]> {
  return apiPatch<IsaCreditRiskTypeBatchRequest, IsaCreditRiskType[]>(
    '/api/isa-credit-risk-types/batch',
    { added, modified, deleted: deletedIds },
  );
}
